//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class DashboardClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retailermetrics(body?: UserFranchiseList | undefined, cancelToken?: CancelToken): Promise<RetailerMetricsResponse> {
        let url_ = this.baseUrl + "/Dashboard/retailermetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetailermetrics(_response);
        });
    }

    protected processRetailermetrics(response: AxiosResponse): Promise<RetailerMetricsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RetailerMetricsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerMetricsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    staleretailers(body?: StaleRetailersRequest | undefined, cancelToken?: CancelToken): Promise<StaleRetailersResponse> {
        let url_ = this.baseUrl + "/Dashboard/staleretailers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaleretailers(_response);
        });
    }

    protected processStaleretailers(response: AxiosResponse): Promise<StaleRetailersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaleRetailersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaleRetailersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retailersbyvalue(body?: RetailersByValueRequest | undefined, cancelToken?: CancelToken): Promise<RetailersByValueResponse> {
        let url_ = this.baseUrl + "/Dashboard/retailersbyvalue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetailersbyvalue(_response);
        });
    }

    protected processRetailersbyvalue(response: AxiosResponse): Promise<RetailersByValueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RetailersByValueResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailersByValueResponse>(null as any);
    }
}

export class DeliveryPricingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param retailerId (optional) 
     * @param enabledOnly (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    rulesGET(retailerId?: number | undefined, enabledOnly?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, cancelToken?: CancelToken): Promise<DeliveryPricingRuleResponsePagedResult> {
        let url_ = this.baseUrl + "/DeliveryPricing/rules?";
        if (retailerId === null)
            throw new globalThis.Error("The parameter 'retailerId' cannot be null.");
        else if (retailerId !== undefined)
            url_ += "retailerId=" + encodeURIComponent("" + retailerId) + "&";
        if (enabledOnly === null)
            throw new globalThis.Error("The parameter 'enabledOnly' cannot be null.");
        else if (enabledOnly !== undefined)
            url_ += "enabledOnly=" + encodeURIComponent("" + enabledOnly) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRulesGET(_response);
        });
    }

    protected processRulesGET(response: AxiosResponse): Promise<DeliveryPricingRuleResponsePagedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeliveryPricingRuleResponsePagedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPricingRuleResponsePagedResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    rulesPOST(body?: CreateDeliveryPricingRuleRequest | undefined, cancelToken?: CancelToken): Promise<DeliveryPricingRuleResponse> {
        let url_ = this.baseUrl + "/DeliveryPricing/rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRulesPOST(_response);
        });
    }

    protected processRulesPOST(response: AxiosResponse): Promise<DeliveryPricingRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = resultData201;
            return Promise.resolve<DeliveryPricingRuleResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPricingRuleResponse>(null as any);
    }

    /**
     * @return Success
     */
    rulesGET2(id: number, cancelToken?: CancelToken): Promise<DeliveryPricingRuleResponse> {
        let url_ = this.baseUrl + "/DeliveryPricing/rules/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRulesGET2(_response);
        });
    }

    protected processRulesGET2(response: AxiosResponse): Promise<DeliveryPricingRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeliveryPricingRuleResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPricingRuleResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rulesPUT(id: number, body?: UpdateDeliveryPricingRuleRequest | undefined, cancelToken?: CancelToken): Promise<DeliveryPricingRuleResponse> {
        let url_ = this.baseUrl + "/DeliveryPricing/rules/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRulesPUT(_response);
        });
    }

    protected processRulesPUT(response: AxiosResponse): Promise<DeliveryPricingRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeliveryPricingRuleResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPricingRuleResponse>(null as any);
    }

    /**
     * @return No Content
     */
    rulesDELETE(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/DeliveryPricing/rules/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRulesDELETE(_response);
        });
    }

    protected processRulesDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolve(body?: ResolveDeliveryPriceRequest | undefined, cancelToken?: CancelToken): Promise<DeliveryPriceResult> {
        let url_ = this.baseUrl + "/DeliveryPricing/resolve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolve(_response);
        });
    }

    protected processResolve(response: AxiosResponse): Promise<DeliveryPriceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DeliveryPriceResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPriceResult>(null as any);
    }
}

export class InterestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    interest(body?: InterestFormModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Interest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInterest(_response);
        });
    }

    protected processInterest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OnboardingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    pagedata( cancelToken?: CancelToken): Promise<OnboardingPageData> {
        let url_ = this.baseUrl + "/Onboarding/pagedata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPagedata(_response);
        });
    }

    protected processPagedata(response: AxiosResponse): Promise<OnboardingPageData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<OnboardingPageData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnboardingPageData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retailers(body?: UserFranchiseList | undefined, cancelToken?: CancelToken): Promise<RetailerListModel> {
        let url_ = this.baseUrl + "/Onboarding/retailers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetailers(_response);
        });
    }

    protected processRetailers(response: AxiosResponse): Promise<RetailerListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RetailerListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerListModel>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getActiveRetailersByCompany(companyId?: number | undefined, cancelToken?: CancelToken): Promise<RetailerIdentifierModel[]> {
        let url_ = this.baseUrl + "/Onboarding/getActiveRetailersByCompany?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveRetailersByCompany(_response);
        });
    }

    protected processGetActiveRetailersByCompany(response: AxiosResponse): Promise<RetailerIdentifierModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RetailerIdentifierModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerIdentifierModel[]>(null as any);
    }

    /**
     * @param storeId (optional) 
     * @return Success
     */
    retailerIdByStore(storeId?: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Onboarding/retailerIdByStore?";
        if (storeId === null)
            throw new globalThis.Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetailerIdByStore(_response);
        });
    }

    protected processRetailerIdByStore(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param storeId (optional) 
     * @param retailerId (optional) 
     * @return Success
     */
    storevalidate(storeId?: string | undefined, retailerId?: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Onboarding/storevalidate?";
        if (storeId === null)
            throw new globalThis.Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (retailerId === null)
            throw new globalThis.Error("The parameter 'retailerId' cannot be null.");
        else if (retailerId !== undefined)
            url_ += "retailerId=" + encodeURIComponent("" + retailerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStorevalidate(_response);
        });
    }

    protected processStorevalidate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param franchiseName (optional) 
     * @return Success
     */
    catalogues(franchiseName?: string | undefined, cancelToken?: CancelToken): Promise<OnboardingCataloguesModel> {
        let url_ = this.baseUrl + "/Onboarding/catalogues?";
        if (franchiseName === null)
            throw new globalThis.Error("The parameter 'franchiseName' cannot be null.");
        else if (franchiseName !== undefined)
            url_ += "franchiseName=" + encodeURIComponent("" + franchiseName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCatalogues(_response);
        });
    }

    protected processCatalogues(response: AxiosResponse): Promise<OnboardingCataloguesModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<OnboardingCataloguesModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnboardingCataloguesModel>(null as any);
    }

    /**
     * @param retailerId (optional) 
     * @param body (optional) 
     * @return Success
     */
    retailer(retailerId?: number | undefined, body?: UserFranchiseList | undefined, cancelToken?: CancelToken): Promise<RetailerOnboardingDataModel> {
        let url_ = this.baseUrl + "/Onboarding/retailer?";
        if (retailerId === null)
            throw new globalThis.Error("The parameter 'retailerId' cannot be null.");
        else if (retailerId !== undefined)
            url_ += "retailerId=" + encodeURIComponent("" + retailerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetailer(_response);
        });
    }

    protected processRetailer(response: AxiosResponse): Promise<RetailerOnboardingDataModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RetailerOnboardingDataModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerOnboardingDataModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body?: RetailerOnboardingDataModel | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Onboarding/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param retailerId (optional) 
     * @return Success
     */
    delete(retailerId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Onboarding/delete?";
        if (retailerId === null)
            throw new globalThis.Error("The parameter 'retailerId' cannot be null.");
        else if (retailerId !== undefined)
            url_ += "retailerId=" + encodeURIComponent("" + retailerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OnboardingDocumentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param documentId (optional) 
     * @param retailerId (optional) 
     * @return Success
     */
    download(documentId?: number | undefined, retailerId?: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/OnboardingDocument/download?";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (retailerId === null)
            throw new globalThis.Error("The parameter 'retailerId' cannot be null.");
        else if (retailerId !== undefined)
            url_ += "retailerId=" + encodeURIComponent("" + retailerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
                const contentType = response.headers["content-type"];
                return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: typeof contentType === "string" ? contentType : undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PricingModelsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    pricingModelsAll( cancelToken?: CancelToken): Promise<PricingModelResponse[]> {
        let url_ = this.baseUrl + "/PricingModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPricingModelsAll(_response);
        });
    }

    protected processPricingModelsAll(response: AxiosResponse): Promise<PricingModelResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PricingModelResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingModelResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    pricingModelsPOST(body?: CreatePricingModelRequest | undefined, cancelToken?: CancelToken): Promise<PricingModelResponse> {
        let url_ = this.baseUrl + "/PricingModels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPricingModelsPOST(_response);
        });
    }

    protected processPricingModelsPOST(response: AxiosResponse): Promise<PricingModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = resultData201;
            return Promise.resolve<PricingModelResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    pricingModelsGET(id: number, cancelToken?: CancelToken): Promise<PricingModelResponse> {
        let url_ = this.baseUrl + "/PricingModels/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPricingModelsGET(_response);
        });
    }

    protected processPricingModelsGET(response: AxiosResponse): Promise<PricingModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PricingModelResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pricingModelsPUT(id: number, body?: UpdatePricingModelRequest | undefined, cancelToken?: CancelToken): Promise<PricingModelResponse> {
        let url_ = this.baseUrl + "/PricingModels/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPricingModelsPUT(_response);
        });
    }

    protected processPricingModelsPUT(response: AxiosResponse): Promise<PricingModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PricingModelResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingModelResponse>(null as any);
    }

    /**
     * @return No Content
     */
    pricingModelsDELETE(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/PricingModels/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPricingModelsDELETE(_response);
        });
    }

    protected processPricingModelsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProductsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upload(body?: ProductDocumentModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ProductDocuments/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return Success
     */
    download2(documentId?: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/ProductDocuments/download?";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload2(_response);
        });
    }

    protected processDownload2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: typeof response.headers["content-type"] === "string" ? response.headers["content-type"] : undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteDocument(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ProductDocuments/delete-document/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export type BillingMode = 1 | 2 | 3;

export interface ConfigurationModel {
    storeId?: string | undefined;
    externalIdentifier?: string | undefined;
    containerSizeId?: number | undefined;
    creditLimit?: number | undefined;
    minContainerFillPercentage?: number | undefined;
    catalogueId?: number | undefined;
    palletSizeId?: number | undefined;
    leadTime?: number | undefined;
    claimPeriod?: number | undefined;
    orderCategories?: number[] | undefined;
    catalogues?: number[] | undefined;
}

export interface ContactDetails {
    name?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    interestReason?: string | undefined;
    rangeRequirements?: string | undefined;
    serviceNeeds?: string | undefined;
}

export interface CreateDeliveryPricingRuleRequest {
    pricingModelId?: number;
    shippingMethodId?: number;
    externalCustomerTypeId?: number | undefined;
    retailerIds?: number[] | undefined;
    effectiveFrom?: DateOnly;
    effectiveTo?: DateOnly;
    priority?: number;
    enabled?: boolean;
}

export interface CreatePricingModelRequest {
    name?: string | undefined;
    modelType?: PricingModelType;
    rateType?: RateType;
    quantityStep?: number | undefined;
    partialQuantityStrategy?: PartialQuantityStrategy;
    roundUpThresholdPercent?: number | undefined;
    billingMode?: BillingMode;
    externalCustomerTypeId?: number | undefined;
    tiers?: TierRequest[] | undefined;
}

export interface DateOnly {
    year?: number;
    month?: number;
    day?: number;
    dayOfWeek?: DayOfWeek;
    readonly dayOfYear?: number;
    readonly dayNumber?: number;
}

export type DayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export interface DeliveryPriceResult {
    resolved?: boolean;
    deliveryPricingRuleId?: number | undefined;
    totalCharge?: number;
    perUnitRate?: number;
    wholePallets?: number;
    partialPalletCharge?: number;
    fullPalletCharge?: number;
    modelName?: string | undefined;
    scope?: string | undefined;
}

export interface DeliveryPricingRuleResponse {
    deliveryPricingRuleId?: number;
    pricingModelId?: number;
    pricingModelName?: string | undefined;
    shippingMethodId?: number;
    externalCustomerTypeId?: number | undefined;
    retailerIds?: number[] | undefined;
    effectiveFrom?: DateOnly;
    effectiveTo?: DateOnly;
    priority?: number;
    enabled?: boolean;
}

export interface DeliveryPricingRuleResponsePagedResult {
    items?: DeliveryPricingRuleResponse[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    readonly totalPages?: number;
}

export interface Int32StringKeyValuePair {
    key?: number;
    value?: string | undefined;
}

export interface InterestFormModel {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    company?: string | undefined;
    country?: string | undefined;
    interest?: string | undefined;
    service?: string | undefined;
    "g-recaptcha-response"?: string | undefined;
    interestRange?: string | undefined;
}

export interface OnboardingCataloguesModel {
    orderCategories?: Int32StringKeyValuePair[] | undefined;
    catalogues?: Int32StringKeyValuePair[] | undefined;
}

export interface OnboardingPageData {
    documentSkeleton?: RetailerDocumentModel[] | undefined;
    palletSizes?: Int32StringKeyValuePair[] | undefined;
    containerSizes?: Int32StringKeyValuePair[] | undefined;
}

export type PartialQuantityStrategy = 1 | 2 | 3 | 4;

export interface PricingModelResponse {
    pricingModelId?: number;
    name?: string | undefined;
    modelType?: PricingModelType;
    rateType?: RateType;
    quantityStep?: number | undefined;
    partialQuantityStrategy?: PartialQuantityStrategy;
    roundUpThresholdPercent?: number | undefined;
    billingMode?: BillingMode;
    externalCustomerTypeId?: number | undefined;
    tiers?: PricingModelTierResponse[] | undefined;
}

export interface PricingModelTierResponse {
    pricingModelTierId?: number;
    fromQuantity?: number;
    toQuantity?: number | undefined;
    rate?: number;
    sortOrder?: number;
}

export type PricingModelType = 1 | 2 | 3;

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ProductDocumentModel {
    id?: number | undefined;
    productId?: number;
    documentId?: number | undefined;
    fileName?: string | undefined;
    altDocName?: string | undefined;
    fileType?: string | undefined;
    fileDataBase64?: string | undefined;
    effectiveStartDate?: string | undefined;
    effectiveEndDate?: string | undefined;
}

export type RateType = 1 | 2;

export interface ResolveDeliveryPriceRequest {
    shippingMethodId?: number;
    retailerId?: number | undefined;
    wholePallets?: number;
    lastPalletFillPercent?: number;
    deliveryDate?: DateOnly;
    baseCharge?: number | undefined;
}

export interface RetailerByValueDto {
    customerId?: number;
    customerNumber?: string | undefined;
    customerName?: string | undefined;
    totalValue?: number;
    orderCount?: number;
}

export interface RetailerDeliveryLocationModel {
    id?: number | undefined;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
}

export interface RetailerDeliveryMethodModel {
    name?: string | undefined;
    retailerId?: number;
    shippingMethodId?: number;
    charge?: number | undefined;
    enabled?: boolean;
    isDefault?: boolean;
    companyId?: number;
    shippingModelId?: number;
}

export interface RetailerDocumentModel {
    documentId?: number | undefined;
    category?: string | undefined;
    header?: string | undefined;
    uploadRequired?: boolean;
    fieldRequired?: boolean;
    fileExists?: boolean;
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileData?: string | undefined;
    approved?: boolean;
    delete?: boolean;
}

export interface RetailerHeaderModel {
    retailerId?: number | undefined;
    statusId?: number | undefined;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    region?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    franchiseName?: string | undefined;
}

export interface RetailerIdentifierModel {
    storeId?: string | undefined;
    externalIdentifier?: string | undefined;
}

export interface RetailerListModel {
    retailerList?: RetailerHeaderModel[] | undefined;
}

export interface RetailerMetrics {
    totalRetailers?: number;
    notStarted?: number;
    inProgress?: number;
    completed?: number;
    completedPercentage?: number;
    completedThisMonth?: number;
    completedLastMonth?: number;
    percentageChange?: number;
}

export interface RetailerMetricsResponse {
    metrics?: RetailerMetrics;
}

export interface RetailerOnboardingDataModel {
    retailerId?: number | undefined;
    statusId?: number | undefined;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    region?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    vatnumber?: string | undefined;
    awrsnumber?: string | undefined;
    eorinumber?: string | undefined;
    parentCompany?: string | undefined;
    directors?: string | undefined;
    progressStage?: boolean;
    franchiseName?: string | undefined;
    contactDetails?: ContactDetails;
    configuration?: ConfigurationModel;
    currentDocuments?: RetailerDocumentModel[] | undefined;
    deliveryLocations?: RetailerDeliveryLocationModel[] | undefined;
    deliveryMethods?: RetailerDeliveryMethodModel[] | undefined;
}

export interface RetailersByValueRequest {
    fromDate?: string;
    toDate?: string;
    franchises?: UserFranchiseList;
}

export interface RetailersByValueResponse {
    retailers?: RetailerByValueDto[] | undefined;
}

export interface StaleRetailerDto {
    customerId?: number;
    customerNumber?: string | undefined;
    customerName?: string | undefined;
    lastOrderDate?: string | undefined;
    daysSinceLastOrder?: number | undefined;
}

export interface StaleRetailersRequest {
    days?: number;
    franchises?: UserFranchiseList;
}

export interface StaleRetailersResponse {
    staleRetailers?: StaleRetailerDto[] | undefined;
}

export interface TierRequest {
    fromQuantity?: number;
    toQuantity?: number | undefined;
    rate?: number;
    sortOrder?: number;
}

export interface UpdateDeliveryPricingRuleRequest {
    pricingModelId?: number;
    shippingMethodId?: number;
    externalCustomerTypeId?: number | undefined;
    retailerIds?: number[] | undefined;
    effectiveFrom?: DateOnly;
    effectiveTo?: DateOnly;
    priority?: number;
    enabled?: boolean;
}

export interface UpdatePricingModelRequest {
    name?: string | undefined;
    modelType?: PricingModelType;
    rateType?: RateType;
    quantityStep?: number | undefined;
    partialQuantityStrategy?: PartialQuantityStrategy;
    roundUpThresholdPercent?: number | undefined;
    billingMode?: BillingMode;
    tiers?: TierRequest[] | undefined;
}

export interface UserFranchiseList {
    franchiseNames?: string[] | undefined;
    franchiseIds?: number[] | undefined;
    currentFranchiseName?: string | undefined;
    otherRegions?: boolean;
    taskView?: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class OfdApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isOfdApiException = true;

    static isOfdApiException(obj: any): obj is OfdApiException {
        return obj.isOfdApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new OfdApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}